import { basic, withUniqueClass } from "../../helpers/block-helpers";

export const contactInfoModule = basic.module({
  id: "contact-info-form",
  label: "Contact Form (Simple Cleaning)",
  description:
    "Contact form styled like the Simple Cleaning template: first/last name, email, phone, service select, message textarea, full-width submit button.",
  content: withUniqueClass("pc-contact-form", (cls, h) => {
    const { companyId, companySlug } = h.company();

    const returnUrl = `https://www.dev-app.flownect.com/marketing/${companySlug}`;
    const actionUrl = `https://earwig-helped-bison.ngrok-free.app/contact`;
    // const returnUrl = `https://earwig-helped-bison.ngrok-free.app/contact`;


    return `
    <div class="${cls}">
      <form class="${cls}__form" action="${actionUrl}" method="POST">

        <input type="hidden" name="companyId" value="${companyId}" />
        <input type="hidden" name="companySlug" value="${companySlug}" />
        <input type="hidden" name="returnUrl" value="${returnUrl}" />
        <input type="text" name="website" value="" style="display:none" tabindex="-1" autocomplete="off" />

        <div class="${cls}__row">
          <div class="${cls}__group">
            <label class="${cls}__label" for="${cls}-fname">First Name</label>
            <input
              class="${cls}__input"
              type="text"
              id="${cls}-fname"
              name="fname"
              placeholder="Maria"
              required
            />
          </div>

          <div class="${cls}__group">
            <label class="${cls}__label" for="${cls}-lname">Last Name</label>
            <input
              class="${cls}__input"
              type="text"
              id="${cls}-lname"
              name="lname"
              placeholder="Torres"
              required
            />
          </div>
        </div>

        <div class="${cls}__group">
          <label class="${cls}__label" for="${cls}-email">Email Address</label>
          <input
            class="${cls}__input"
            type="email"
            id="${cls}-email"
            name="email"
            placeholder="maria@example.com"
            required
          />
        </div>

        <div class="${cls}__group">
          <label class="${cls}__label" for="${cls}-phone">Phone Number</label>
          <input
            class="${cls}__input"
            type="tel"
            id="${cls}-phone"
            name="phone"
            placeholder="+1 (212) 000-0000"
          />
        </div>

        <div class="${cls}__group">
          <label class="${cls}__label" for="${cls}-service">Service Needed</label>
          <select class="${cls}__select" id="${cls}-service" name="service">
            <option value="">Select a service…</option>
            <option>Residential Cleaning</option>
            <option>Office &amp; Commercial</option>
            <option>Move-In / Move-Out</option>
            <option>Post-Construction</option>
            <option>Carpet &amp; Upholstery</option>
            <option>Window &amp; Facade</option>
          </select>
        </div>

        <div class="${cls}__group">
          <label class="${cls}__label" for="${cls}-message">Message</label>
          <textarea
            class="${cls}__textarea"
            id="${cls}-message"
            name="message"
            rows="4"
            placeholder="Tell us about your space and any specific requirements…"
          ></textarea>
        </div>

        <button class="${cls}__btn ${cls}__btnFull" type="submit">
          Send My Request
        </button>
      </form>

      <style>
        .${cls} {
          width: 100%;
        }

        .${cls}__form {
          background: #FFFFFF;
          border: 1px solid #E4EAF0;
          border-radius: 12px;
          padding: 44px 40px;
          box-shadow: 0 4px 24px rgba(15, 31, 46, 0.10);
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .${cls}__row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .${cls}__group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .${cls}__label {
          font-family: 'Source Sans 3', sans-serif;
          font-size: 0.82rem;
          font-weight: 600;
          letter-spacing: 0.05em;
          color: #1C2B3A;
          text-transform: uppercase;
        }

        .${cls}__input,
        .${cls}__select,
        .${cls}__textarea {
          border: 1.5px solid #E4EAF0;
          border-radius: 6px;
          padding: 12px 16px;
          font-family: 'Source Sans 3', sans-serif;
          font-size: 0.95rem;
          color: #1C2B3A;
          background: #F5F7F9;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
          -webkit-appearance: none;
          appearance: none;
        }

        .${cls}__input::placeholder,
        .${cls}__textarea::placeholder {
          color: #7A94AD;
        }

        .${cls}__input:focus,
        .${cls}__select:focus,
        .${cls}__textarea:focus {
          border-color: #4ECDC4;
          box-shadow: 0 0 0 3px rgba(78, 205, 196, 0.15);
          background: #FFFFFF;
        }

        .${cls}__select {
          background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%234A607A' stroke-width='2'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
          background-repeat: no-repeat;
          background-position: right 14px center;
          background-color: #F5F7F9;
          padding-right: 40px;
          cursor: pointer;
        }

        .${cls}__textarea {
          resize: vertical;
        }

        .${cls}__btn {
          width: 100%;
          padding: 13px;
          background: #4ECDC4;
          color: #0F1F2E;
          font-family: 'Source Sans 3', sans-serif;
          font-size: 0.95rem;
          font-weight: 600;
          border: none;
          border-radius: 6px;
          cursor: pointer;
          letter-spacing: 0.02em;
          transition: background 0.2s, transform 0.2s, box-shadow 0.2s;
        }

        .${cls}__btn:hover {
          background: #38b2aa;
          transform: translateY(-2px);
          box-shadow: 0 8px 20px rgba(78, 205, 196, 0.3);
        }

        @media (max-width: 720px) {
          .${cls}__row {
            grid-template-columns: 1fr;
          }

          .${cls}__form {
            padding: 32px 24px;
          }
        }
      </style>
    </div>
  `;
  }),
});